// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HeaderClientWrapper_headerWrapper__EC1aM","headerWrapper_HP":"HeaderClientWrapper_headerWrapper_HP__INDby"};